<template>
    <div class="review-icon rounded-circle square d-flex align-items-center justify-content-center" :class="icon">
        <i :class="iconClass" v-if="!is_swell"></i>
        <i class="fab fa-tripadvisor" v-if="is_tripAdvisor"></i>
        <img v-if="is_swell" src="/img/logo-small-white.png" style="max-width: 24px;" />
        <img v-if="is_software_advice" src="/img/logo-software-advice.png" style="max-width: 24px;" />
        <img v-if="is_zillow" src="/img/logo-zillow.png" style="max-width: 24px;" />
        <img v-if="is_healthgrades" src="/img/logo-healthgrades.png" style="max-width: 24px;" />
        <span class="font-weight-bold" v-if="is_vitals">V</span>
    </div>

</template>

<style lang="scss" scoped>
.square {
    width: 40px;
    height: 40px;
}
.review-icon {
    background: #0374d7;
    color: white;

    &.facebook {
        background: #4267b2;
    }
    &.google {
        background: #ea4335;
    }
    &.yelp {
        background: #cb2027;
    }
    &.software_advice {
        background: #333;
    }
    &.trip_advisor {
        background: #83BD56;
    }
    &.vitals {
        background-image: linear-gradient(to right, #9c27b0, #5e35b1 40%, #311b92);
    }
    &.healthgrades {
        background: white;
        border: 1px solid #626366;
    }
}
</style>

<script>
export default {
    props: {
        icon: { default: 'swell' }
    },

    computed: {
        iconClass() {
            switch (this.icon) {
                case 'google': return 'fab fa-google';
                case 'facebook': return 'fab fa-facebook-f';
                case 'yelp': return 'fab fa-yelp';
                default: return '';
            }
        },

        is_swell() { return this.icon === 'swell' },

        is_software_advice() { return this.icon === 'software_advice' },

        is_zillow() { return this.icon === 'zillow' },

        is_vitals() { return this.icon === 'vitals' },

        is_healthgrades() { return this.icon === 'healthgrades' },

        is_tripAdvisor() { return this.icon === 'trip_advisor' },
    }
}
</script>
